import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseControlValueAccessor } from 'rev-shared/util/BaseControlValueAccessor';
import { IRegistrationField } from 'rev-shared/metadata/Metadata.Contract';
import { MetadataService } from 'rev-shared/metadata/Metadata.Service';
import { UserContextService } from 'rev-shared/security/UserContext.Service';

import { IRegistrationFieldSelection } from '../EditWebcast.Contract';

@Component({
	selector: 'select-registration-fields',
	templateUrl: './SelectRegistrationFields.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => SelectRegistrationFieldsComponent),
		multi: true
	}],
	standalone: false
})
export class SelectRegistrationFieldsComponent extends BaseControlValueAccessor<IRegistrationFieldSelection[]> {
	@Output() public onReady: EventEmitter<void> = new EventEmitter();

	private readonly accountId = this.UserContext.getAccount().id;
	public registrationFields: IRegistrationField[];

	constructor(
		private readonly TranslateService: TranslateService,
		private readonly MetadataService: MetadataService,
		private readonly UserContext: UserContextService
	) {
		super();
	}

	public writeValue(val: IRegistrationFieldSelection[]): void {
		this.value = val;
	}

	public ngOnInit(): void {
		this.MetadataService.loadAccountRegistrationFields(this.accountId)
			.then(() => {
				this.registrationFields = this.MetadataService.getAccountRegistrationFields(this.accountId);
				if(this.registrationFields.length > 0) {
					this.onReady.emit();
				}
			});
	}

	public isFieldSelected = (field: IRegistrationFieldSelection) => field.includedByHost;
	public isFieldForceSelected = (field: IRegistrationFieldSelection) => field.includeInAllWebcasts;
	public getFieldName = (field: IRegistrationFieldSelection) => field.name;
	public getFieldSubheading = (field: IRegistrationFieldSelection) => field.required ? this.TranslateService.instant('Media_Required') : '';
	public setSelected = (field: IRegistrationFieldSelection, isSelected: boolean) => field.includedByHost = isSelected;

	public onChange(): void {
		this.updateModelValue(this.value);
	}

}
